//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class BoundingBoxConstants
{
	public static worldBoundWest: number = -137.51807;
	public static worldBoundSouth: number = -54.99314;
	public static worldBoundEast: number = 92.54448;
	public static worldBoundNorth: number = 72.47242;
}
